var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1771_7009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.1724,
    height: 18.1724,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1771_7009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07156 17.148C7.43197 17.148 6.00303 16.6082 4.78475 15.5288C3.56646 14.4493 2.8651 13.0961 2.68066 11.4691H3.8397C4.03094 12.7767 4.61946 13.8608 5.60525 14.7214C6.59105 15.5819 7.74649 16.0122 9.07156 16.0122C10.5481 16.0122 11.8006 15.498 12.8291 14.4694C13.8576 13.4409 14.3718 12.1884 14.3718 10.7119C14.3718 9.23542 13.8576 7.98291 12.8291 6.9544C11.8006 5.92589 10.5481 5.41164 9.07156 5.41164C8.24449 5.41164 7.46935 5.59535 6.74614 5.96277C6.02294 6.33019 5.4002 6.83571 4.87794 7.47932H6.85826V8.61507H3.01415V4.77095H4.14988V6.5649C4.76436 5.83976 5.50019 5.27697 6.35736 4.87653C7.21453 4.4761 8.11926 4.27588 9.07156 4.27588C9.96465 4.27588 10.8014 4.44479 11.5819 4.78262C12.3624 5.12044 13.0429 5.5796 13.6234 6.16009C14.2039 6.7406 14.663 7.4211 15.0009 8.20158C15.3387 8.98206 15.5076 9.81884 15.5076 10.7119C15.5076 11.605 15.3387 12.4418 15.0009 13.2223C14.663 14.0028 14.2039 14.6832 13.6234 15.2638C13.0429 15.8442 12.3624 16.3034 11.5819 16.6412C10.8014 16.9791 9.96465 17.148 9.07156 17.148ZM11.3446 13.761L8.52552 10.942V6.926H9.66128V10.4819L12.1425 12.9631L11.3446 13.761Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceReset);
export default __webpack_public_path__ + "static/media/device_reset.8bf6b79ca9234464262d0156b05c4861.svg";
export { ForwardRef as ReactComponent };